import { render } from "./ClientMenuTab.vue?vue&type=template&id=505f5a88&scoped=true"
import script from "./ClientMenuTab.vue?vue&type=script&lang=js"
export * from "./ClientMenuTab.vue?vue&type=script&lang=js"

import "./ClientMenuTab.vue?vue&type=style&index=0&id=505f5a88&lang=stylus&scoped=true"

import exportComponent from "D:\\01.WorkData\\05.WebProjects\\04.SourceCode\\02.Vue\\project_110_008\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505f5a88"]])

export default __exports__